module.exports = {"title":"Course Selection","invalidUserInfo":"User information is invalid."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/accountclubs.json
// module id = IfFV
// module chunks = 2